import { TextAlignment } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';
import Renderable, { RenderEventListener } from '@philips-emr/tws-core/lib/component/types/renderable';
import Sortable, { SortEventListener } from '@philips-emr/tws-core/lib/component/types/sortable';
import { isEnumValid } from '@philips-emr/tws-utils';

import { ColumnType } from './constants';

interface Superscription {
  color: string;
  label?: string;
  value: string;
}

class DataTableColumnAPI extends ComponentAPI implements Clickable, Sortable, Renderable {

  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onSort = new SortEventListener();

  /** @event */
  @AwesomeEvent
  onDynamicContentRender = new RenderEventListener();

  getAligment(): TextAlignment {
    return this.state.aligment;
  }

  setAligment(aligment: TextAlignment): void {
    if (isEnumValid(TextAlignment, aligment)) {
      this.setState({ aligment });
    }
  }

  getClassName(): string {
    return this.state.className;
  }

  setClassName( className: string ): void {
    this.setState({ className });
  }

  isShowSuperscriptionLabel(): boolean {
    return this.state.showSuperscriptionLabel;
  }

  setShowSuperscriptionLabel(showSuperscriptionLabel: boolean): void {
    this.setState({ showSuperscriptionLabel });
  }

  isSortable(): boolean {
    return this.state.sortable;
  }

  setSortable(sortable: boolean): void {
    this.setState({ sortable });
  }

  getSuperscription(): Superscription[] {
    return this.state.superscription;
  }

  setSuperscription(superscription: Superscription[]): void {
    if (Array.isArray(superscription)) {
      this.setState({ superscription });
    }
  }

  getType(): ColumnType {
    return this.state.type;
  }

  setType(type: ColumnType): void {
    if (isEnumValid(ColumnType, type)) {
      this.setState({ type });
    }
  }

  getValue(): string {
    return this.state.value;
  }

  setValue(value: string): void {
    this.setState({ value });
  }

  isVisible(): boolean {
    return this.state.visible;
  }

  setVisible(visible: boolean): void {
    this.setState({ visible });
  }

  getWidth(): number {
    return this.state.width;
  }

  setWidth(width: number): void {
    if (isFinite(width)) {
      this.setState({ width });
    }
  }

}

export default DataTableColumnAPI;
